import Button from '@/common/components/base/button/Button';
import DashedTitle from '@/common/components/base/dashedTitle/DashedTitle';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import CompletingImages from '@/common/components/camera/components/completingImages/CompletingImages';
import { SliderEnum } from '@/common/components/camera/types/components.type';
import { ImageType } from '@/common/components/imageGallery/components/Extensions/moreItemsExtension/moreItemsExtension.type';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import useModal from '@/common/hooks/useModal';
import { useReloadWarning } from '@/common/hooks/useReloadWarning';
import DamagePartEmptySpace from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/DamagePartEmptySpace';
import ImageActions from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/ImageActions';
import ImageGrid from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/ImageGrid';
import RepeatCapturingModal from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/vehicleImages/vehicleDamageImagePreview/RepeatCapturingModal';
import { useImageFlowStore } from '@/modules/adjusterReportModules/IncidentParticipants/store/imageFlow/useImageFlowStore';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const UnsentImagePreview = ({
  onSubmit,
  repeatCapturing,
}: {
  repeatCapturing: () => void;
  onSubmit: () => void;
}) => {
  useReloadWarning();
  const {
    closeModal: repeatCaptureCloseModal,
    open: repeatCaptureOpen,
    openModal: repeatCaptureOpenModal,
  } = useModal();

  const { video, setImages, images, resetCameraStore, deleteDamagePart } =
    useImageFlowStore();

  const { closeModal, open, openModal } = useModal();
  const handleOpenCompletingImages = () => {
    openModal();
  };

  const handleCompleteImages = (data: ImageType[] = []) => {
    setImages({ images: data, type: SliderEnum.EXTRA_IMAGES });
    closeModal();
  };

  const repeatCapturingHandler = () => {
    resetCameraStore();
    repeatCapturing();
  };
  return (
    <Box pt={24}>
      <Flex alignItems="center" justifyContent="space-between">
        <TitleDescription>تصاویر وسیله‌نقلیه</TitleDescription>
      </Flex>
      <Box mt={24}>
        <DashedTitle title="تصاویر دور تا دور وسیله‌نقلیه" />
      </Box>
      <Flex
        gap={16}
        mt={16}
        flexDir="row"
        flexWrap="wrap"
        className={grid({ columns: 2 })}
      >
        {images.vehicleImages?.length > 0 ? (
          images.vehicleImages?.map((image, index) => (
            <Box
              key={image.url || index}
              minW={146}
              flex={
                index === images.vehicleImages?.length - 1 &&
                (!video?.url || images.vehicleImages?.length % 2 === 0)
                  ? 'unset'
                  : 1
              }
            >
              <ImageCard
                imageData={{
                  name: image?.label || 'تصویر دور تا دور',
                  src: image.url,
                }}
              />
            </Box>
          ))
        ) : (
          <Box p={4}>
            <Typography>هیچ تصویری از وسیله‌نقلیه موجود نیست</Typography>
          </Box>
        )}
      </Flex>
      {images.damagedImages?.length > 0 ? (
        <ImageGrid
          handleDelete={deleteDamagePart}
          images={images.damagedImages}
          title={<DashedTitle title="تصاویر نقاط آسیب‌دیده" />}
        />
      ) : (
        <Box mt={24}>
          <DashedTitle title="تصاویر نقاط آسیب‌دیده" />
          <Box mt={16} mb={16}>
            <DamagePartEmptySpace />
          </Box>
        </Box>
      )}

      {images.extraImages?.length > 0 && (
        <ImageGrid
          images={images.extraImages.map((img, idx) => ({
            ...img,
            label: `تصویر تکمیلی - ${idx + 1}`,
          }))}
          title={<DashedTitle title="تصاویر تکمیلی" />}
        />
      )}
      <ImageActions
        onOpenCompletingImages={handleOpenCompletingImages}
        onRetakeImages={repeatCaptureOpenModal}
      />

      {open && (
        <CompletingImages
          closeCamera={closeModal}
          maxTotalImages={15}
          onCompleteImages={handleCompleteImages}
          totalImagesCount={images.extraImages?.length}
        />
      )}

      <RepeatCapturingModal
        closeModal={repeatCaptureCloseModal}
        repeatCapturing={repeatCapturingHandler}
        open={repeatCaptureOpen}
      />

      <Button fullWidth variant="contained" mt={16} onClick={onSubmit}>
        ثبت
      </Button>
    </Box>
  );
};

export default UnsentImagePreview;
